import React from "react";
import Layout from "../hocs/Layout";
import {connect} from "react-redux";
import Banner from "../components/home/banner";
import AboutMe from "../components/home/about_me";
import Service from "../components/home/service";
import Skill from "../components/home/skill";
import Experience from "../components/home/experience";
import Portafolio from "../components/home/portafolio";

const Home = () => {
    return (
        <Layout>
        <Banner/>
        <AboutMe/>
        <Service/>
        <Skill/>
        <Experience/>
        <Portafolio/>
        </Layout>
    );
};


const mapStateToProps = state => ({})

export default connect(mapStateToProps, {})(Home)
